import { trackEvent } from '@/lib/trackEvent';

/** @deprecated Prefer `trackEvent` from `@/lib/trackEvent` with canonical event names. */
export async function trackClientEvent(eventType, opts = {}) {
  const legacy = {
    lead_created: 'form_submitted',
    payment_success: 'payment_success',
    report_viewed: 'report_viewed',
  };
  const name = legacy[eventType] || eventType;
  return trackEvent(name, opts);
}
